import React from "react"
import { Layout, Menu, Avatar, MenuProps } from "antd"
import { useKindeAuth } from "@kinde-oss/kinde-auth-react"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faCircleArrowRight,
  // faPenToSquare,
} from "@fortawesome/free-solid-svg-icons"

import { getFirstLetters } from "utils/getFirstLetters"
import { KindeUser } from "types/kinde.types"

// Define props interface
interface DesktopHeaderProps {
  mode?: "horizontal" | "vertical" | "inline"
}

// Define the menu item type
type MenuItem = Required<MenuProps>["items"][number]

/**
 * Represents the desktop header component.
 * @param props - The component props
 * @returns {JSX.Element} The JSX element representing the desktop header component.
 */
const DesktopHeader: React.FC<DesktopHeaderProps> = ({ mode }) => {
  const { Header } = Layout
  const { logout, user } = useKindeAuth()

  // Type assertion for user object with null check
  const kindeUser = user as KindeUser | null

  /**
   * An array of menu items for the profile dropdown.
   */
  const menuItems: MenuItem[] = [
    {
      key: "unit-switcher",
      icon: <></>,
    },
    {
      key: "profile",
      label: `${kindeUser?.givenName || "User"}`,
      icon: (
        <Avatar
          style={{ backgroundColor: "#36C2EC", color: "white" }}
          className="p-5"
        >
          {getFirstLetters([kindeUser?.givenName, kindeUser?.familyName])}
        </Avatar>
      ),
      children: [
        // {
        //   label: "Settings",
        //   key: "settings",
        //   icon: (
        //     <FontAwesomeIcon
        //       className="flex flex-shrink-0 h-4 text-black mt-1 mr-2"
        //       icon={faPenToSquare}
        //     />
        //   ),
        // },
        {
          label: "Logout",
          key: "logout",
          onClick: (): void => {
            logout()
          },
          icon: (
            <FontAwesomeIcon
              className="flex flex-shrink-0 h-4 text-black mt-1 mr-2"
              icon={faCircleArrowRight}
            />
          ),
        },
      ],
    },
  ]

  /**
   * Renders the desktop header component.
   * @returns {JSX.Element} The JSX element representing the desktop header.
   */
  return (
    <Header className="site-layout-background flex p-0 bg-white">
      <img
        src="/assets/images/data-q-logo-black-n-blue.png"
        alt="logo"
        className="w-48 p-2 self-center"
      />
      <Menu
        mode={mode === undefined ? "horizontal" : mode}
        className="desktop-nav w-full"
        items={menuItems}
      />
    </Header>
  )
}

export default DesktopHeader
